export default "__VITE_ASSET__DP2qTWtg__"